import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { Box, ListItem, ListItemText } from "@mui/material";
import {
  EnvironmentVariables,
  MainSidebarListProps,
} from "@/modules/common/types";
import { OrganizationTierTypes } from "@/modules/common/types";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel } from "@/modules/common/types";
import { PermissionsEnum } from "@/modules/common/types";
import { CalculatorIcon } from "@/modules/common/components/ui-kit/icons/calculator-icon";
import { PathConstants } from "@/routes/constants";
import ClipboardListIcon from "@/modules/common/components/ui-kit/icons/clipboard-list-icon";
import CalendarDaysIcon from "@/modules/common/components/ui-kit/icons/calendar-days-icon";

export const ExtraList = ({
  handleCalendarClick,
  handleClipboardClick,
  getNavLinkStyles,
  handleItemClick,
  StyledListItemButton,
}: MainSidebarListProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        paddingBottom: nawyTheme.nawy.spacing.lg,
      }}
    >
      <ListItem disablePadding>
        <StyledListItemButton onClick={handleCalendarClick}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: nawyTheme.nawy.spacing.xs,
            }}
          >
            <CalendarDaysIcon />
            <ListItemText primary="Meetings" />
          </Box>
        </StyledListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <StyledListItemButton onClick={handleClipboardClick}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: nawyTheme.nawy.spacing.xs,
            }}
          >
            <ClipboardListIcon />
            <ListItemText primary="Tasks" />
          </Box>
        </StyledListItemButton>
      </ListItem>
      {EnvironmentVariables.COMPANY_NAME.toString() ===
        OrganizationTierTypes.NAWY && (
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.NAWY_NOW_CALCULATOR,
              level: PermissionLevel.READ,
            },
            {
              name: PermissionsEnum.NAWY_UNLOCKED_CALCULATOR,
              level: PermissionLevel.READ,
            },
          ]}
        >
          <ListItem disablePadding>
            <StyledListItemButton
              selected={getNavLinkStyles(PathConstants.NAWY_CALCULATOR)}
              onClick={() => handleItemClick(PathConstants.NAWY_CALCULATOR)}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: nawyTheme.nawy.spacing.xs,
                }}
              >
                <CalculatorIcon />

                <ListItemText primary="Nawy Calculator" />
              </Box>
            </StyledListItemButton>
          </ListItem>
        </PermissionGuard>
      )}
    </Box>
  );
};
